module.exports = __webpack_public_path__ + "img/businesstoday.54157806.svg";